import React, { memo } from 'react';
import * as Icon from 'ubs-icons';

const DocumentLoading = memo(() => (
  <div className="u_text-center u_p-4 u_color-white">
    <div><Icon.Preloader /></div>
    <p>Loading document preview...</p>
  </div>
));

export default DocumentLoading; 